export default "__VITE_ASSET__d500f62e__"